export { AppIcon } from './AppIcon'
